export const config = {
  locale: 'ru',
  yearNow: new Date(Date.now()).getFullYear(),
}
